var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow",
        },
      ],
      staticClass: "notice-main",
      on: { click: _vm.goTo },
    },
    [
      _c("img", { staticClass: "notice-img", attrs: { src: _vm.notice_img } }),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _c("div", { ref: "scroll", staticClass: "scroll-up" }, [
          _c(
            "ul",
            { staticClass: "tran", attrs: { id: "listUL" } },
            _vm._l(_vm.newsListR, function (item, index) {
              return _c("li", { key: index }, [_vm._v(_vm._s(item))])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.newsLists.length >= 2,
              expression: "newsLists.length >= 2",
            },
          ],
          staticClass: "num",
        },
        [_vm._v("\n    共" + _vm._s(_vm.newsLists.length) + "条\n  ")]
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "arrow-right",
        attrs: { src: _vm.arrow_right },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }